import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SimpleHeaderBlockConfig } from '@front-platform/content-builder';
import { simpleHeaderBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface SimpleHeaderBlockRuntimeConfig {
  'left_items'?: any[];
  'middle_items'?: any[];
  'right_items'?: any[];
}

export type SimpleHeaderBlockConfigInput = Partial<
  Omit<SimpleHeaderBlockConfig, keyof SimpleHeaderBlockRuntimeConfig> &
    SimpleHeaderBlockRuntimeConfig
>;
export type SimpleHeaderBlockResolvedConfig = Omit<
  SimpleHeaderBlockConfig,
  keyof SimpleHeaderBlockRuntimeConfig
> &
  Partial<SimpleHeaderBlockRuntimeConfig>;
export interface SimpleHeaderBlockContract extends ConfigComponentContract<
  SimpleHeaderBlockConfigInput,
  SimpleHeaderBlockResolvedConfig
> {}

@Component({
  selector: 'app-simple-header-block',
  templateUrl: './simple-header-block.component.html',
  styles: [],
  standalone: false,
})
export class SimpleHeaderBlockComponent implements SimpleHeaderBlockContract {
  readonly config = input<SimpleHeaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SimpleHeaderBlockConfig,
    SimpleHeaderBlockRuntimeConfig
  >(simpleHeaderBlockResolveConfig, () => ({ config: this.config() }));
  get leftItems(): any[] {
    return this.resolvedConfig()['left_items'] as unknown as any[];
  }
  get middleItems(): any[] {
    return this.resolvedConfig()['middle_items'] as unknown as any[];
  }
  get rightItems(): any[] {
    return this.resolvedConfig()['right_items'] as unknown as any[];
  }

  get height(): string {
    return this.resolvedConfig()['height'] as unknown as string;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  constructor() {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SimpleHeaderBlockComponent, { 'keyAliases': {} });
